import { DEFAULT_LOCALE, getLocalDateTime } from '@skytech/utils'

import { useAppContext } from '@/app/index.context'

export const useLocalDateTime = () => {
  const { locale } = useAppContext()

  const formatTime = ({ date, showDate = true }: { date: string; showDate?: boolean }) => {
    if (!date) return ''
    return getLocalDateTime({
      date,
      locale: locale || DEFAULT_LOCALE,
      showDate,
    })
  }

  return { formatTime }
}
